export const baseURL = "https://pay.moxey.ai";
export const contactURL = "/website-lead-generation/details";
